var $;

$ = require('jquery');

module.exports = $(document).ready(function() {
  var addPaddingToPortfolio, boxClassesArray, boxClicked, boxIndex, boxesArray, deselectAll, fadeAll, hideAll, hideAllExcept, prepNextButton, removePaddingFromPortfolio, resetItems, scrollToPortfolio, totalBoxes;
  boxesArray = [];
  boxClassesArray = [];
  boxIndex = 0;
  $(".portfolio-box").each(function() {
    boxesArray.push(this);
    $(boxesArray[boxIndex]).click(function() {
      var boxNumber;
      boxClassesArray[boxIndex] = $(this).attr('class');
      boxNumber = boxClassesArray[boxIndex].slice(17);
      return boxClicked(boxNumber);
    });
    return boxIndex++;
  });
  totalBoxes = boxesArray.length;
  hideAll = function() {
    var j;
    j = 0;
    while (j <= totalBoxes) {
      $(".item" + j).hide();
      j++;
    }
    return $(".portfolio-next").hide();
  };
  hideAllExcept = function(itemNumber) {
    $('.about-images').hide();
    hideAll();
    $(".item" + itemNumber).fadeIn('slow');
    return $(".portfolio-next").fadeIn('slow');
  };
  fadeAll = function() {
    var i, _results;
    i = 0;
    _results = [];
    while (i <= totalBoxes) {
      $(".item" + i).fadeOut();
      _results.push(i++);
    }
    return _results;
  };
  deselectAll = function() {
    var i, _results;
    i = 0;
    _results = [];
    while (i <= totalBoxes) {
      $(".box" + i).removeClass("selected");
      _results.push(i++);
    }
    return _results;
  };
  addPaddingToPortfolio = function() {
    return $('section.portfolio-content').animate({
      'padding-top': '30px',
      'padding-bottom': '30px'
    });
  };
  removePaddingFromPortfolio = function() {
    return $('section.portfolio-content').animate({
      'padding-top': '0',
      'padding-bottom': '0'
    });
  };
  scrollToPortfolio = function() {
    var navHeight, portfolioContentTop, usableTop;
    navHeight = $('nav.nav').outerHeight();
    portfolioContentTop = $('section.portfolio-content').position().top;
    usableTop = 0;
    if (portfolioContentTop > 300) {
      usableTop = 183;
    } else {
      usableTop = portfolioContentTop;
    }
    return addPaddingToPortfolio().promise().then(function() {
      return $('html, body').stop().animate({
        scrollTop: usableTop - navHeight
      });
    });
  };
  prepNextButton = function(nextItem) {
    $(".portfolio-next").show();
    $(".portfolioitem-item").unbind('click');
    return $(".portfolioitem-item").click(function() {
      return boxClicked(nextItem);
    });
  };
  boxClicked = function(boxNumber) {
    boxNum;
    var boxNum, itemNumber, lastBoxClicked, nextItem;
    if (boxNumber.length > 3) {
      boxNum = boxNumber.substring(0, boxNumber.length - 9);
      boxNumber = boxNum;
    }
    if ((boxNumber !== 0) && (lastBoxClicked === boxNumber)) {
      return console.log("Clicked Already");
    } else {
      if (boxNumber === 0) {
        boxNumber = 1;
      }
      lastBoxClicked = boxNumber;
      deselectAll();
      $(".box" + boxNumber).addClass("selected");
      $(".portfolio-next").hide();
      itemNumber = parseInt(boxNumber);
      nextItem = itemNumber + 1;
      if (nextItem > totalBoxes) {
        nextItem = 1;
      }
      scrollToPortfolio();
      hideAllExcept(itemNumber);
      return prepNextButton(nextItem);
    }
  };
  resetItems = function() {};
  hideAll();
  $('.about-images').show();
  resetItems();
  $(".nav-link-about, .nav-link-skillset, .nav-link-contact, .nav-link-logo").click(function() {
    var introVisible;
    introVisible = $('.about-images').css("display");
    if (introVisible === "none") {
      hideAll();
      deselectAll();
      $('.about-images').fadeIn('slow');
      return removePaddingFromPortfolio();
    }
  });
  $(".about-images").click(function() {
    return boxClicked(0);
  });
  return $(".nav-link-portfolio").click(function() {
    return boxClicked(0);
  });
});
